// src/pages/pengamatan/sensus-populasi-anakan-pisang/SensusPopulasiAnakanPisangTableHeader.jsx
import React from 'react';
import { TableHead, TableRow, TableCell, Checkbox } from '@mui/material';
import './css/SensusPopulasiAnakanPisangTableHeader.css';

const SensusPopulasiAnakanPisangTableHeader = ({ 
    selectedItems, 
    orders, 
    handleSelectAll,
    areAllItemsOnCurrentPageSelected 
}) => {
    const headerConfig = [
        { 
            id: 'checkbox', 
            label: '', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header fixed checkbox',
            component: (
                <Checkbox
                    indeterminate={selectedItems.length > 0 && !areAllItemsOnCurrentPageSelected()}
                    checked={orders.length > 0 && areAllItemsOnCurrentPageSelected()}
                    onChange={handleSelectAll}
                />
            )
        },
        // ... konfigurasi header lainnya tetap sama
        { 
            id: 'status_pengamatan', 
            label: 'Status Pengamatan', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header fixed status-pengamatan'
        },
        { 
            id: 'tanggal_pengamatan', 
            label: 'Tanggal Pengamatan', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header fixed tanggal-pengamatan'
        },
        { 
            id: 'block', 
            label: 'Block', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header fixed block'
        },
        { 
            id: 'plot', 
            label: 'Plot', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header fixed plot'
        },
        { 
            id: 'luas', 
            label: 'Luas', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header'
        },
        { 
            id: 'rta', 
            label: 'Rumpun Tanpa Anakan', 
            rowSpan: 1, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header'
        },
        { 
            id: 'rda', 
            label: 'Rumpun Dengan Anakan', 
            rowSpan: 1, 
            colSpan: 4,
            className: 'sensus-populasi-anakan-pisang-table-header'
        },
        { 
            id: 'rdat', 
            label: 'Rumpun Dengan Anakan Tanpa Tagging', 
            rowSpan: 1, 
            colSpan: 4,
            className: 'sensus-populasi-anakan-pisang-table-header'
        },
        { 
            id: 'total', 
            label: 'Total', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header'
        },
        { 
            id: 'keterangan', 
            label: 'Keterangan', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'sensus-populasi-anakan-pisang-table-header'
        }
    ];

    const subHeaderConfig = [
        { 
            id: 'rta_0', 
            label: '(0)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rda_1', 
            label: '(1)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rda_2', 
            label: '(2)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rda_3', 
            label: '(3)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rda_4', 
            label: '(4)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rdat_1', 
            label: '(1)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rdat_2', 
            label: '(2)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rdat_3', 
            label: '(3)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        },
        { 
            id: 'rdat_4', 
            label: '(4)', 
            className: 'sensus-populasi-anakan-pisang-sub-header'
        }
    ];

    return (
        <TableHead>
            {/* Baris Header Pertama */}
            <TableRow>
                {headerConfig.map((header) => (
                    <TableCell
                        key={header.id}
                        rowSpan={header.rowSpan}
                        colSpan={header.colSpan}
                        className={header.className}
                        padding={header.id === 'checkbox' ? 'checkbox' : 'normal'}
                    >
                        {header.component || header.label}
                    </TableCell>
                ))}
            </TableRow>
            
            {/* Baris Header Kedua (Sub-header untuk BIBIT) */}
            <TableRow>
                {subHeaderConfig.map((subHeader) => (
                    <TableCell
                        key={subHeader.id}
                        className={subHeader.className}
                    >
                        {subHeader.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default SensusPopulasiAnakanPisangTableHeader;